export const EXP_POINTS = 'xP';

export const EMPTY_STATE_IMAGES = {
  signUpbanner: 'https://res.cloudinary.com/samvibes/image/upload/signup-banner.png',
  docsPrivate: 'https://res.cloudinary.com/samvibes/image/upload/empty%20states/docs-private.png',
  docsShared: 'https://res.cloudinary.com/samvibes/image/upload/empty%20states/docs-shared.png',
  docsDeleted: 'https://res.cloudinary.com/samvibes/image/upload/empty%20states/docs-deleted.png',
  docsArchived: 'https://res.cloudinary.com/samvibes/image/upload/empty%20states/docs-archived.png',
  creationsPrivate:
    'https://res.cloudinary.com/samvibes/image/upload/empty%20states/creations-private.png',
  creationsShared:
    'https://res.cloudinary.com/samvibes/image/upload/empty%20states/creation-shared.png',
  creationsDeleted:
    'https://res.cloudinary.com/samvibes/image/upload/empty%20states/creations-deleted.png',
  creationsArchived:
    'https://res.cloudinary.com/samvibes/image/upload/empty%20states/creations-archived.png',
  boardsPrivate:
    'https://res.cloudinary.com/samvibes/image/upload/empty%20states/boards-private.png',
  assignedTasks:
    'https://res.cloudinary.com/samvibes/image/upload/empty%20states/assigned_tasks.png',

  boardsShared: 'https://res.cloudinary.com/samvibes/image/upload/empty%20states/boards-share.png',
  bookmarks:
    'https://res.cloudinary.com/samvibes/image/upload/empty%20states/empty_state_bookmarks.png',
  comments: 'https://cms.staging.sketchnote.co/uploads/comments_empty_placeholder_ef99713bcd.png',
  creationsComplete:
    'https://res.cloudinary.com/samvibes/image/upload/empty%20states/creation-completed.png',
  lessonInProgress:
    'https://res.cloudinary.com/samvibes/image/upload/empty_state_lessons_in_progress_ecd307b9cd.png',
  lessonCompleted:
    'https://res.cloudinary.com/samvibes/image/upload/Empty_state_lessons_completed_0308a13f13.png',
  lessonSaved:
    'https://res.cloudinary.com/samvibes/image/upload/v1628518881/Empty_state_lessons_saved_54b4309cc2.png',
  statisticsAchievement:
    'https://cms.staging.sketchnote.co/uploads/statistics_and_achievements_picture_8e180b1650.png',
  lessonCreation:
    'https://res.cloudinary.com/samvibes/image/upload/v1616736917/Creation_Start_daa18b429f.png',
  profile:
    'https://firebasestorage.googleapis.com/v0/b/user-login-test-c2254.appspot.com/o/Martin.png?alt=media&token=e02aeb64-7b5e-48d2-829e-f5fe4927ec49',
  notifications:
    'https://res.cloudinary.com/samvibes/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1623836303/notifications_empty.svg',
  avatar: 'https://res.cloudinary.com/samvibes/image/upload/empty%20states/avatar_emoty_state.png',
  analytics: 'https://res.cloudinary.com/samvibes/image/upload/empty%20states/analytics.png',
  timesheet:
    'https://res.cloudinary.com/samvibes/image/upload/v1655446532/empty%20states/timesheet.png',
  curiculum:
    'https://res.cloudinary.com/samvibes/image/upload/v1675263330/empty%20states/curiculum-empty-state.png',
  discussions_empty:
    'https://res.cloudinary.com/samvibes/image/upload/v1675263330/empty%20states/discussions-empty-state.png',
  comments_empty:
    'https://res.cloudinary.com/samvibes/image/upload/v1683885744/empty%20states/comments.png',
  analytics_empty:
    'https://res.cloudinary.com/samvibes/image/upload/v1684395176/empty%20states/lms-analytics-empty-state.webp',
};
